export default __webpack_public_path__ + "static/activity_image-5ea06bec41d5e6aff5c76bab621978b5.jpg";